import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GiftOutlined } from '@ant-design/icons';
import { ArrowRight } from 'lucide-react';
import { offerService } from '../services/api';

// Curated featured offers (mirror the Offers page). Live API offers are shown
// first when available; these are the reliable fallback / always-on promos.
const FEATURED = [
  'Dashain Dhamaka · Up to 35% off appliances & gadgets',
  'Service Combo · 20% off any repair booking',
  'Free delivery on orders over Rs 5,000 inside the Valley',
];

const OffersBanner = () => {
  const navigate = useNavigate();
  const [offers, setOffers] = useState(FEATURED);
  const [idx, setIdx] = useState(0);

  // Pull live offers and lead with them (latest first).
  useEffect(() => {
    let alive = true;
    offerService
      .getOffers()
      .then((res) => {
        const raw = res.data?.data || res.data || [];
        const live = (Array.isArray(raw) ? raw : [])
          .map((o) => {
            const title = o.title || o.name;
            const detail = o.discount_percentage
              ? `Up to ${o.discount_percentage}% off`
              : o.subtitle || o.short_description || '';
            return [title, detail].filter(Boolean).join(' · ');
          })
          .filter(Boolean);
        if (alive && live.length) setOffers([...live, ...FEATURED].slice(0, 6));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  // Rotate through the offers.
  useEffect(() => {
    if (offers.length < 2) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % offers.length), 4500);
    return () => clearInterval(t);
  }, [offers]);

  return (
    <button
      type="button"
      onClick={() => navigate('/offers')}
      aria-label="View special offers"
      style={{ background: 'linear-gradient(90deg, #fe9c07, #ffb63f)', cursor: 'pointer' }}
      className="flex w-full cursor-pointer items-center justify-center gap-2 px-4 py-2 text-[0.82rem] font-semibold text-ink transition hover:brightness-[0.97]"
    >
      <GiftOutlined style={{ fontSize: 14 }} />
      <span key={idx} className="offers-banner-text truncate">
        {offers[idx]}
      </span>
      <span className="ml-1 hidden items-center gap-1 font-bold sm:inline-flex">
        Shop offers <ArrowRight size={13} />
      </span>
    </button>
  );
};

export default OffersBanner;
